import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'antd/dist/reset.css';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollToTop from './components/ScrollToTop';
import { addResourceHints, measureCoreWebVitals } from './utils/performance';

// Import Calmi components
import Calmi from './app/views/Calmi';
import CalmiWellness from './app/views/CalmiWellness';
import CalmiPlatform from './app/views/CalmiPlatform';
import CalmiHeart from './app/views/CalmiHeart';
import CalmiHeartBrands from './app/views/CalmiHeartBrands';
import CalmiHeartOEMs from './app/views/CalmiHeartOEMs';
import CalmiHeartTechnical from './app/views/CalmiHeartTechnical';
import Blog from './app/views/Blog';
import BlogPost from './app/views/BlogPost';
import AutoBlog from './app/views/AutoBlog';
import FAQ from './app/views/FAQ';
import SEOAnalytics from './app/views/SEOAnalytics';
import AuthCallback from './components/AuthCallback';
import NewYork from './app/views/locations/NewYork';
import LosAngeles from './app/views/locations/LosAngeles';
import Chicago from './app/views/locations/Chicago';
import Houston from './app/views/locations/Houston';
import Miami from './app/views/locations/Miami';

// Import product components
import CalmiClassic from './app/views/products/CalmiClassic';
import CalmiClassicBear from './app/views/products/CalmiClassicBear';
import CalmiUnicorn from './app/views/products/CalmiUnicorn';
import CalmiLion from './app/views/products/CalmiLion';
import CalmiSquishyBear from './app/views/products/CalmiSquishyBear';
import CalmiSquishyLion from './app/views/products/CalmiSquishyLion';
import CalmiSquishyUnicorn from './app/views/products/CalmiSquishyUnicorn';
import CalmiGentle from './app/views/products/CalmiGentle';
import CalmiDeep from './app/views/products/CalmiDeep';
import CalmiTravel from './app/views/products/CalmiTravel';
import CalmiPocket from './app/views/products/CalmiPocket';
import CalmiNight from './app/views/products/CalmiNight';
import LunaLion from './app/views/products/LunaLion';

function App() {
  // Initialize performance optimizations
  useEffect(() => {
    // Add resource hints for better performance
    addResourceHints();
    
    // Start measuring Core Web Vitals
    measureCoreWebVitals();
    
    // Preload critical fonts
    if (document.fonts) {
      document.fonts.ready.then(() => {
        // Font loading complete
      });
    }
  }, []);

  return (
    <Router>
      <GoogleAnalytics />
      <ScrollToTop />
      <div className="App">
        <Switch>
          {/* Main Calmi Store - Root Page */}
          <Route exact path="/" component={Calmi} />
          
          {/* Calmi Section Routes */}
          <Route path="/wellness" component={CalmiWellness} />
          <Route path="/platform" component={CalmiPlatform} />
          
          {/* Blog Routes */}
          <Route exact path="/blog" component={Blog} />
          <Route path="/blog/:slug" component={BlogPost} />
          
          {/* AutoBlog Route */}
          <Route path="/autoblog" component={AutoBlog} />
          
          {/* FAQ Route */}
          <Route path="/faq" component={FAQ} />
          
          {/* SEO Analytics Route (internal) */}
          <Route path="/seo-analytics" component={SEOAnalytics} />
          
          {/* OAuth Callback Route */}
          <Route path="/auth/callback" component={AuthCallback} />
          
          {/* Location Routes */}
          <Route path="/locations/new-york" component={NewYork} />
          <Route path="/locations/los-angeles" component={LosAngeles} />
          <Route path="/locations/chicago" component={Chicago} />
          <Route path="/locations/houston" component={Houston} />
          <Route path="/locations/miami" component={Miami} />
          <Route path="/heart" component={CalmiHeart} />
          <Route path="/heart/brands" component={CalmiHeartBrands} />
          <Route path="/heart/oems" component={CalmiHeartOEMs} />
          <Route path="/heart/technical" component={CalmiHeartTechnical} />

          {/* Product Routes */}
          <Route path="/products/lumi-classic" component={CalmiClassic} />
          <Route path="/products/lumi-classic-bear" component={CalmiClassicBear} />
          <Route path="/products/lumi-unicorn" component={CalmiUnicorn} />
          <Route path="/products/lumi-lion" component={CalmiLion} />
          <Route path="/products/lumi-squishy-bear" component={CalmiSquishyBear} />
          <Route path="/products/lumi-squishy-lion" component={CalmiSquishyLion} />
          <Route path="/products/lumi-squishy-unicorn" component={CalmiSquishyUnicorn} />
          <Route path="/products/lumi-gentle" component={CalmiGentle} />
          {/* Backward compatibility routes */}
          <Route path="/products/calmi-classic" component={CalmiClassic} />
          <Route path="/products/calmi-classic-bear" component={CalmiClassicBear} />
          <Route path="/products/calmi-unicorn" component={CalmiUnicorn} />
          <Route path="/products/calmi-lion" component={CalmiLion} />
          <Route path="/products/calmi-squishy-bear" component={CalmiSquishyBear} />
          <Route path="/products/calmi-squishy-lion" component={CalmiSquishyLion} />
          <Route path="/products/calmi-squishy-unicorn" component={CalmiSquishyUnicorn} />
          <Route path="/products/calmi-gentle" component={CalmiGentle} />
          <Route path="/products/calmi-deep" component={CalmiDeep} />
          <Route path="/products/calmi-travel" component={CalmiTravel} />
          <Route path="/products/calmi-pocket" component={CalmiPocket} />
          <Route path="/products/calmi-night" component={CalmiNight} />
          <Route path="/products/luna-lion" component={LunaLion} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;